/* eslint-disable no-unused-vars */
import { useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Languages } from 'constants/dictionary/languages';
import { campaignLangs } from 'store/selectors';
import { sortLanguagesByLanguageName } from 'utils';
import { generalActions } from 'store/actions';

export const useFacade = () => {
  const dispatch = useDispatch();
  const selectedLangs = useSelector(campaignLangs);

  const allLanguages = useMemo(() => {
    const res = Languages.languages.reduce(function (acc, { language_code, language_name }) {
      if (!acc.find((item) => item.language_code === language_code)) {
        acc = [...acc, { language_code, language_name }];
        return acc;
      }
      return acc;
    }, []);
    return sortLanguagesByLanguageName(res);
  }, [Languages]);

  const langCodeToData = useMemo(() => {
    const res = Object.fromEntries(
      allLanguages.map(({ language_code, language_name }) => [language_code, language_name]),
    );
    return res;
  }, [allLanguages]);

  const upDateStore = useCallback((newValue = '') => {
    const data = typeof newValue === 'string' ? newValue : '';
    dispatch(
      generalActions.updateCurrentCampaignObj({
        propField: 'campaignLangs',
        newValue: data,
      }),
    );
  }, []);

  const deleteLangBtn = useCallback(
    (langCode) => {
      dispatch(
        generalActions.updateCurrentCampaignObj({
          propField: 'campaignLangs',
          newValue: selectedLangs.filter((code) => code !== langCode).join(','),
        }),
      );
    },
    [selectedLangs],
  );

  return { selectedLangs, upDateStore, deleteLangBtn, langCodeToData };
};
